"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshottedStateEngine = exports.SnapshottedStateEngineStateType = exports.VersionedStateEngine = exports.StateEngine = void 0;
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("underscore"));
var definitions_1 = require("./definitions");
var StateEngine = /** @class */ (function () {
    function StateEngine(baseEvents) {
        this.baseEvents = baseEvents;
        this.nextEventOffset = 0;
        this.idToIndexMap = {};
    }
    Object.defineProperty(StateEngine.prototype, "latestState", {
        get: function () {
            return this.getLatestState();
        },
        enumerable: false,
        configurable: true
    });
    StateEngine.prototype.stateBeforeEventOrUndefined = function (eventIndex) {
        try {
            this.stateBeforeEvent(eventIndex);
        }
        catch (error) {
            return undefined;
        }
    };
    StateEngine.prototype.stateBeforeEventId = function (eventId) {
        return this.stateBeforeEvent(this.indexForEventId(eventId));
    };
    // If eventId is undefined, then return latestState else return stateBefore it.
    StateEngine.prototype.stateBeforeEventIdOrLatest = function (eventId) {
        if (eventId !== undefined) {
            return this.stateBeforeEvent(this.indexForEventId(eventId));
        }
        else {
            return this.latestState;
        }
    };
    StateEngine.prototype.stateAfterEvent = function (eventIndex) {
        return this.stateBeforeEvent(eventIndex + 1);
    };
    StateEngine.prototype.stateAfterEventId = function (eventId) {
        return this.stateAfterEvent(this.indexForEventId(eventId));
    };
    StateEngine.prototype.indexForEventId = function (eventId) {
        return this.idToIndexMap[eventId];
    };
    // Returns boolean of whether anything was processed
    StateEngine.prototype.processToBeforeEvent = function (eventIndex) {
        if (eventIndex > this.baseEvents.length || eventIndex === 0) {
            return false;
        }
        while (this.nextEventOffset < eventIndex) {
            this.fullyProcessNextEvent();
        }
        return true;
    };
    StateEngine.prototype.processToLatestEvent = function () {
        while (this.nextEventOffset < this.baseEvents.length) {
            this.fullyProcessNextEvent();
        }
    };
    StateEngine.prototype.fullyProcessNextEvent = function () {
        var nextEvent = this.nextEvent;
        if (nextEvent === undefined) {
            return;
        }
        var id = (0, definitions_1.idFromEvent)(nextEvent);
        this.idToIndexMap[id] = this.nextEventOffset;
        this.preProcessEvent(nextEvent);
        this.processNextEvent();
        this.nextEventOffset++;
        this.postProcessEvent(nextEvent);
    };
    // Subclasses can override these functions to perform actions before and after
    // the main event processing step
    StateEngine.prototype.preProcessEvent = function (_event) {
        return;
    };
    StateEngine.prototype.postProcessEvent = function (_event) {
        return;
    };
    Object.defineProperty(StateEngine.prototype, "nextEvent", {
        get: function () {
            return this.baseEvents[this.nextEventOffset];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateEngine.prototype, "lastEvent", {
        get: function () {
            if (this.nextEventOffset === 0) {
                return undefined;
            }
            return this.baseEvents[this.nextEventOffset - 1];
        },
        enumerable: false,
        configurable: true
    });
    return StateEngine;
}());
exports.StateEngine = StateEngine;
var VersionedStateEngine = /** @class */ (function (_super) {
    tslib_1.__extends(VersionedStateEngine, _super);
    function VersionedStateEngine(baseEvents) {
        var _this = _super.call(this, baseEvents) || this;
        _this.baseEvents = baseEvents;
        _this.stateHistory = [];
        var initialState = _this.initialState().set('nextEventOffset', _this.nextEventOffset);
        _this.stateHistory.push(initialState);
        return _this;
    }
    VersionedStateEngine.prototype.get = function (key) {
        return this.currentState.toJS()[key];
    };
    VersionedStateEngine.prototype.getLatest = function (key) {
        return this.latestState.toJS()[key];
    };
    VersionedStateEngine.prototype.getLatestState = function () {
        this.processToLatestEvent();
        return this.stateHistory[this.nextEventOffset];
    };
    Object.defineProperty(VersionedStateEngine.prototype, "currentState", {
        get: function () {
            return this.stateHistory[this.nextEventOffset];
        },
        enumerable: false,
        configurable: true
    });
    VersionedStateEngine.prototype.stateBeforeEvent = function (eventIndex) {
        if (eventIndex < 0 || eventIndex > this.baseEvents.length) {
            throw new definitions_1.InvalidStateAccessorError(definitions_1.AccessorType.Before, eventIndex.toString());
        }
        this.processToBeforeEvent(eventIndex);
        return this.stateHistory[eventIndex];
    };
    VersionedStateEngine.prototype.processNextEvent = function () {
        var stateAfterEvent = this.processOneEvent(this.currentState, this.nextEvent);
        if (stateAfterEvent) {
            var nextHistory = stateAfterEvent.set('nextEventOffset', this.nextEventOffset);
            this.stateHistory.push(nextHistory);
        }
    };
    // TODO: Clean up idToIndexMap on rollback? May not be necessary
    VersionedStateEngine.prototype.rollbackToBeforeEvent = function (eventIndex) {
        if (eventIndex > this.stateHistory.length - 1) {
            return;
        }
        this.nextEventOffset = eventIndex;
        this.stateHistory.splice(eventIndex + 1, Infinity);
    };
    return VersionedStateEngine;
}(StateEngine));
exports.VersionedStateEngine = VersionedStateEngine;
// Snapshotted engines need to restore state from serialized JSON.
// JSON cannot have methods on it. So in order to get back a fully initialized
// state object, each SnapshottedStateEngine's state will need to implement
// the restoreFromSnapshot method.
// This function will be responsible for getting the deserialized JSON object
// and copying all of its relevant attributes to the state's attributes
// i.e.  this.importantStateAttribute = stateObject['importantStateAttribute'];
var SnapshottedStateEngineStateType = /** @class */ (function () {
    function SnapshottedStateEngineStateType() {
    }
    return SnapshottedStateEngineStateType;
}());
exports.SnapshottedStateEngineStateType = SnapshottedStateEngineStateType;
var SnapshottedStateEngine = /** @class */ (function (_super) {
    tslib_1.__extends(SnapshottedStateEngine, _super);
    function SnapshottedStateEngine(baseEvents) {
        var _this = _super.call(this, baseEvents) || this;
        _this.baseEvents = baseEvents;
        // Attempt to maintain snapshots at roughly these intervals from the current head
        // This list should be sorted in ascending order
        _this.snapshotIntervals = [10, 40, 80];
        _this.snapshotRotationInterval = 10;
        _this.eventsSinceLastRotation = 0;
        _this.snapshots = {};
        // Extension engines are versioned engines that are completely
        // owned by their parent snapshotted engine. These are processed
        // and rolled back in lockstep with the parent. Extensions can
        // be useful to track versioned data based off of a snapshotted
        // engine's data.
        _this.extensionEngines = [];
        _this.resetToInitialState();
        return _this;
    }
    SnapshottedStateEngine.prototype.get = function (key) {
        return this.currentState[key];
    };
    SnapshottedStateEngine.prototype.getLatest = function (key) {
        return this.latestState[key];
    };
    Object.defineProperty(SnapshottedStateEngine.prototype, "currentState", {
        get: function () {
            return this.state;
        },
        enumerable: false,
        configurable: true
    });
    SnapshottedStateEngine.prototype.getLatestState = function () {
        this.processToLatestEvent();
        return this.state;
    };
    // This forces a rollback against a snapshotted engine, so only
    // use it if you really need to
    SnapshottedStateEngine.prototype.stateBeforeEvent = function (eventIndex) {
        if (eventIndex < 0 || eventIndex > this.baseEvents.length) {
            throw new definitions_1.InvalidStateAccessorError(definitions_1.AccessorType.Before, eventIndex.toString());
        }
        if (eventIndex === this.nextEventOffset) {
            return this.currentState;
        }
        this.rollbackToBeforeEvent(eventIndex);
        return this.currentState;
    };
    SnapshottedStateEngine.prototype.resetToInitialState = function () {
        this.state = this.initialState();
        this.snapshots = {};
        this.nextEventOffset = 0;
        this.eventsSinceLastRotation = 0;
    };
    SnapshottedStateEngine.prototype.copyState = function () {
        return JSON.parse(JSON.stringify(this.state));
    };
    SnapshottedStateEngine.prototype.rotateSnapshots = function () {
        var snapshotsToKeep = {};
        // nextEventOffset was already incremented for this event
        var justProcessedOffset = this.nextEventOffset - 1;
        // Pretty naive algorithm here, find the closest snapshot (favoring earliest)
        // to each interval point and delete all the other ones.
        var snapshotIndices = _.sortBy(Object.keys(this.snapshots).map(Number), function (idx) { return -1 * Number(idx); });
        for (var _i = 0, _a = this.snapshotIntervals; _i < _a.length; _i++) {
            var interval = _a[_i];
            var candidate = snapshotIndices[0];
            for (var _b = 0, snapshotIndices_1 = snapshotIndices; _b < snapshotIndices_1.length; _b++) {
                var snapshotIndex = snapshotIndices_1[_b];
                if (Number(snapshotIndex) < justProcessedOffset + 1 - interval) {
                    break;
                }
                else {
                    candidate = snapshotIndex;
                }
            }
            if (candidate !== undefined) {
                snapshotsToKeep[candidate] = true;
            }
        }
        for (var snapshotIndex in this.snapshots) {
            if (!this.snapshots.hasOwnProperty(snapshotIndex)) {
                continue;
            }
            if (snapshotsToKeep[snapshotIndex] !== true) {
                delete this.snapshots[snapshotIndex];
            }
        }
        // Snapshots are indexed on the before state (e.g. snapshot at 5
        // holds the state before event index 5 is processed)
        this.snapshots[justProcessedOffset + 1] = this.copyState();
        this.eventsSinceLastRotation = 0;
    };
    SnapshottedStateEngine.prototype.processNextEvent = function () {
        this.processOneEvent(this.state, this.nextEvent);
        this.eventsSinceLastRotation++;
    };
    SnapshottedStateEngine.prototype.postProcessEvent = function (_event) {
        for (var _i = 0, _a = this.extensionEngines; _i < _a.length; _i++) {
            var extension = _a[_i];
            extension.fullyProcessNextEvent();
        }
        if (this.eventsSinceLastRotation >= this.snapshotRotationInterval) {
            this.rotateSnapshots();
        }
    };
    // Rollback to the latest possible snapshot before the given eventIndex,
    // then process back up to that index, potentially recreating new
    // snapshots along the way. After you call this, the engine will be
    // at the eventIndex.
    SnapshottedStateEngine.prototype.rollbackToBeforeEvent = function (eventIndex) {
        // Find latest possible snapshot to roll back to, or reset state entirely
        // if we cannot find a suitable snapshot
        var rollbackIndex;
        var snapshotIndices = _.sortBy(Object.keys(this.snapshots).map(Number), function (idx) { return -1 * Number(idx); });
        for (var _i = 0, snapshotIndices_2 = snapshotIndices; _i < snapshotIndices_2.length; _i++) {
            var snapshotIndex = snapshotIndices_2[_i];
            if (Number(snapshotIndex) < eventIndex) {
                rollbackIndex = Number(snapshotIndex);
                break;
            }
            else {
                // this snapshot is soon to be useless anyway, go ahead and delete it
                delete this.snapshots[snapshotIndex];
            }
        }
        if (rollbackIndex === undefined) {
            this.resetToInitialState();
            for (var _a = 0, _b = this.extensionEngines; _a < _b.length; _a++) {
                var extension = _b[_a];
                extension.rollbackToBeforeEvent(0);
            }
            this.processToBeforeEvent(eventIndex);
            return;
        }
        for (var _c = 0, _d = this.extensionEngines; _c < _d.length; _c++) {
            var extension = _d[_c];
            extension.rollbackToBeforeEvent(rollbackIndex);
        }
        // *fuck* you, javascript and your lack of modulo operator
        var _e = [
            this.eventsSinceLastRotation,
            this.nextEventOffset - rollbackIndex,
            this.snapshotRotationInterval,
        ], base = _e[0], change = _e[1], mod = _e[2];
        this.eventsSinceLastRotation = (((base - change) % mod) + mod) % mod;
        this.nextEventOffset = rollbackIndex;
        this.state.restoreFromSnapshot(JSON.parse(JSON.stringify(this.snapshots[rollbackIndex])));
        this.processToBeforeEvent(eventIndex);
    };
    return SnapshottedStateEngine;
}(StateEngine));
exports.SnapshottedStateEngine = SnapshottedStateEngine;
//# sourceMappingURL=engine.js.map